import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLaunchpadComponent } from './simple-icons-launchpad.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLaunchpadComponent ],
    exports:      [ SimpleIconsLaunchpadComponent ],
    bootstrap:    []
})
export class SimpleIconsLaunchpadModule {}
